<template>
    <div>
        <p>
            V Tuš Cash & Carry z največjo odgovornostjo in skladno z vsakokrat veljavnim zakonom o varstvu osebnih podatkov ter določili evropske Uredbe na področju varstva osebnih podatkov (GDPR) skrbimo za vaše podatke. Privolitve lahko spremenite v svojem spletnem profilu oziroma na načine, opisane v splošnih pogojih poslovanja Tuš Cash & Carry kluba.
        </p>
        <p>
            Za dodatne informacije smo vam na voljo na telefonski številki 059 73 44 44 ali na e-naslovu narocilacc@tus.si.
        </p>
        <empty-space />
        <v-layout align-center justify-center row wrap>
            <v-flex xs12 sm12>
                <split-content text="Privolitve"/>
                <empty-space />
                <p>
                    Dovoljujem, da podjetje Engrotuš, d.o.o. obdeluje moje podatke, za spodaj opredeljene namene (Prosimo označite, ali se strinjate z obdelovanjem vaših osebnih podatkov za zapisan namen):
                </p>
                <consents :vuex_module="vuexModule" :vuex_module_path_prefix="vuexModulePathPrefix" />
                <split-content text="" />
                <empty-space />
            </v-flex>
        </v-layout>
        <v-btn depressed large block color="primary_action" @click="saveConsents()" :loading="loading">POTRDI</v-btn>
        <empty-space />
        <v-layout align-center justify-center row wrap>
            <v-flex xs12 sm12 class="explain">
                <h4>Obrazložitev namenov obdelovanja osebnih podatkov:</h4>
                <p>
                    Pri obveščanju preko SMS/MMS sporočil se Tuš Cash & Carry klub član strinja, da se lahko njegovi osebni podatki, ki jih je vpisal v pristopni obrazec in podatki pridobljeni preko sodelovanja v nagradnih igrah, s komunikacijo preko e-pošte, komunikacije s Tuševim centrom za pomoč strankam, uporabe spletnih aplikacij uporabljajo za namene SMS in MMS obveščanja o ugodnostih, aktivnostih, storitvah in dogodkih Tuš Cash&Carry. Podatki se lahko obdelujejo do preklica privoljenja oz. do prenehanja članstva v Tuš Cash & Carry klubu oziroma prenehanju pogodbe.
                </p>

                <p>
                    Pri pošiljanju prilagojene ponudbe se posameznik strinja, da se lahko njegovi podatki, ki jih je vpisal v pristopni obrazec, podatki o posameznih nakupih in podatki pridobljeni preko sodelovanja v nagradnih igrah, s komunikacijo preko e-pošte, komunikacije s Tuševim centrom za pomoč strankam, uporabe spletnih aplikacij, obdelujejo za namene priprave prilagojene ponudbe. V okviru priprave prilagojene ponudbe se izvaja profiliranje na podlagi podanih podatkov ter podatkov o obiskanih spletnih straneh organizacije (če se je posameznik ob obisku spletne strani s tem strinjal) ter posredovanje obvestil na kanale, ki jih je posameznik označil. Za namen priprave prilagojene ponudbe se uporabljajo vsi podani podatki, ki se hranijo od pričetka članstva v Tuš Cash & Carry klubu do poteka zakonskih rokov, opredeljenih v splošnih pogojih. Podatki se prenehajo obdelovati v primeru preklica privoljenja oz. do prenehanja članstva v Tuš Cash & Carry klubu. Prilagojene ponudbe se posredujejo na kanala, ki jih je posameznik označil.
                </p>

                <p>
                    S podpisom ste seznanjeni, da lahko v vsakem trenutku prekličete privolitev za uporabo svojih osebnih podatkov na isti način kot ste privolitev podali, da ste seznanjeni s pravico do seznanitve osebnih podatkov, pravico dopolnitve, popravka, omejitve obdelave, izbrisa, prenosljivosti in ugovora ter s pravico vložiti pritožbo pri Informacijskem pooblaščencu. S podpisom se strinjate s splošnimi pogoji poslovanja Tuš Cash & Carry kluba, ki so v uporabi od 15. 11. 2018 in ki so na voljo na prodajnih mestih Tuš Cash & Carry ter na spletni strani www.tuscc.si.
                </p>

            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import Consents from "./Consents";
    import {userService} from "../services";
    import EmptySpace from "../components/EmptySpace";
    import SplitContent from "../components/SplitContent";

    export default {
        name: "ConsentsEditor",
        components: {Consents, EmptySpace, SplitContent},
        props: {
            for_registration: {
                type: Boolean,
                default: true
            }
        },
        data: vm => ({
            loading: false
        }),
        computed: {
            vuexModule(){
                if (this.for_registration == false){
                    return 'profile';
                }
                return 'registration';
            },
            vuexModulePathPrefix(){
                if (this.for_registration == false){
                    return 'user.consents';
                }
                return null;
            }
        },
        methods: {
            saveConsents(){
                this.loading = true;
                let channels = this.$store.state.registration.consent_channels;
                if (!this.for_registration){
                    channels = this.$store.state.profile.user.consents.consent_channels;
                }
                let consents = {
                    'consent_channels': channels
                }
                userService.saveConsents(consents).then(
                    (data)=> {
                        this.$emit('saved');
                    },
                    (error) => {
                        this.$emit('error', error);
                    }
                ).finally(()=>{
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>
